export default function NotEnoughItemsToCompare() {
  return (
    <div className="mx-4 hidden items-center justify-center rounded-md bg-white p-4 italic text-neutral-500 shadow-md sm:flex">
      You must select at least two rows to compare. Select no rows to compare
      all.
    </div>
  )
}
